import { Typography } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../../../../App';
import { ReactComponent as IncomingTxn } from '../../../../Assets/incomingTxn.svg';
import { ReactComponent as OutgoingTxn } from '../../../../Assets/outgoingTxn.svg';
import { formatToINR } from '../../../../Utils/utils';
import TransactionIcon from '../../../Dashboard/Common/TransactionIcon';
import styles from './index.module.css';

const SIBTransactionCard: React.FC<{
  transaction: any;
  iconSize?: any;
  transactionImageBGProp?: any;
  showDateOfTransaction?: boolean;
  isPendingRec?: boolean;
  isCompletedRec?: boolean;
}> = ({
  transaction,
  iconSize,
  transactionImageBGProp,
  showDateOfTransaction,
  isCompletedRec,
  isPendingRec,
}) => {
  const { isAmountVisible }: any = useContext(AppContext);

  let merchantName;
  if (transaction?.displayName) {
    merchantName = transaction.displayName.split('-');
  } else if (transaction?.category) {
    merchantName = transaction.category.split('-');
  } else if (transaction?.narration) {
    merchantName = transaction.narration.split('-');
  }

  const isCredit = transaction?.type?.toLowerCase().startsWith('c');

  return (
    <>
      <TransactionIcon
        category={transaction.category}
        categoryCode={transaction.categoryCode}
        iconSize={iconSize}
        merchantLogoCode={transaction.merchantLogoCode}
        transactionImageBGProp={transactionImageBGProp}
      />

      <div className={styles.transactionInfo}>
        <Typography.Text className={styles.merchantName} ellipsis>
          {merchantName && merchantName.length >= 2
            ? merchantName[1]
            : merchantName?.[0]}
        </Typography.Text>
        {transaction.id && (
          <Typography.Text className={styles.categoryName} ellipsis>
            {merchantName && merchantName.length > 1
              ? merchantName[0]
              : 'Others'}
          </Typography.Text>
        )}
      </div>

      <div className={styles.amountSection}>
        <div className={styles.amountCol}>
          <Typography.Text
            className={`${styles.amount} ${isCredit ? styles.creditAmount : styles.debitAmount}`}
          >
            {transaction && (transaction.amount || transaction.format)
              ? transaction.format
                ? formatToINR(transaction.lastAmount, isAmountVisible)
                : formatToINR(transaction.amount.toString(), isAmountVisible)
              : ''}
          </Typography.Text>
          {showDateOfTransaction && (
            <Typography.Text className={styles.dateText}>
              {(() => {
                const date =
                  transaction.dateOfTransaction ??
                  (isCompletedRec ? transaction.lastTransactionDate : null) ??
                  (isPendingRec ? transaction.upcomingDate : null) ??
                  transaction.dateOfTransaction;
                return date
                  ? new Date(date).toLocaleDateString('en-IN', {
                      day: 'numeric',
                      month: 'short',
                      year: '2-digit',
                      // Render the transaction's own date (UTC), not shifted to
                      // the device timezone.
                      timeZone: 'UTC',
                    })
                  : '';
              })()}
            </Typography.Text>
          )}
        </div>
        {transaction?.type ? (
          isCredit ? (
            <IncomingTxn />
          ) : transaction.type.toLowerCase().startsWith('d') ? (
            <OutgoingTxn />
          ) : null
        ) : null}
      </div>
    </>
  );
};

export default SIBTransactionCard;
